/**
 * Cardiologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: CARD
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const cardiologie = defineSpecialty(
{
  "id": "cardiologie",
  "label": "Cardiologie",
  "short": "cardiologie",
  "scope": "Cardiologie, rythmologie, hémodynamique et insuffisance cardiaque",
  "aliases": [
    "CARD"
  ],
  "doctorSpecs": [
    "Cardiologie",
    "Médecine interne"
  ],
  "featureFlag": "ux.v2.cardiologie",
  "theme": {
    "primary": "oklch(0.70 0.19 22)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "ecg",
      "label": "ECG",
      "icon": "Activity",
      "route": "/clinical/ecg",
      "order": 2,
      "requires": [
        "ecg"
      ]
    },
    {
      "id": "holter",
      "label": "Holter 24 h",
      "icon": "HeartPulse",
      "route": "/clinical/holter",
      "order": 3,
      "requires": [
        "ecg"
      ]
    },
    {
      "id": "echo",
      "label": "Échographie",
      "icon": "Waves",
      "route": "/clinical/imaging",
      "order": 4,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    },
    {
      "id": "billing",
      "label": "Cotations",
      "icon": "Receipt",
      "route": "/clinical/billing",
      "order": 6,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "ecg",
      "label": "ECG",
      "icon": "Activity",
      "component": "EcgViewer",
      "order": 1,
      "requires": []
    },
    {
      "id": "rhythm",
      "label": "Rythme",
      "icon": "HeartPulse",
      "component": "CardiacRhythm",
      "order": 2,
      "requires": []
    },
    {
      "id": "vitals",
      "label": "Constantes",
      "icon": "Gauge",
      "component": "VitalSignsGrid",
      "order": 3,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 4,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Cardiologie",
    "subSpecialties": [
      "Consultation",
      "ECG",
      "Holter",
      "Échographie",
      "Exploration"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "I00",
      "I05",
      "I10",
      "I25",
      "I48",
      "I50"
    ],
    "loinc": [
      "11524-6",
      "33762-6",
      "27401-9"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "ecg-12-lead",
    "holter-24h",
    "echo-porter",
    "telemetry-cardiac"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default cardiologie;
